import { getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { employerWalletRef } from "../firestore/refs";
import { sanitizeForFirestore } from "../firestore/sanitize";

const INITIAL_BALANCE_CENTS = 10000; // $100.00

/**
 * Ensure employer has a wallet with $100. Idempotent; merge so we don't overwrite existing balance.
 */
export async function ensureEmployerWallet(employerUid: string): Promise<void> {
  const ref = employerWalletRef(employerUid);
  const snap = await getDoc(ref);
  if (snap.exists()) return;
  await setDoc(
    ref,
    sanitizeForFirestore({
      balanceCents: INITIAL_BALANCE_CENTS,
      currency: "USD",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }),
    { merge: true }
  );
}
